module.exports = __webpack_public_path__ + "static/media/bales-1920.03738194.jpg";